import type { GridRenderCellParams } from '@mui/x-data-grid-premium'
import { Dash } from 'settle-ui/components/Dash/Dash'
import { EMPTY_CELL_VALUE } from 'settle-ui/components/DataGrid/DataGrid.consts'

export const renderTruncateStartCell = ({ formattedValue }: GridRenderCellParams) => (
  <span>{formattedValue === EMPTY_CELL_VALUE ? <Dash /> : String(formattedValue)}</span>
)
